import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Thumbnail = styled.div`
	background-image: url(${(props) => props.src});
	background-size: cover;
	background-position: center;
	width: 100%;
	height: 100%;
	position: absolute;
	inset: 0;
	transition: transform 0.3s ease;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
	    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));
		z-index: 1;
		transition: background 0.3s ease;
	}
`;

const CardWrapper = styled.div`
	position: relative;
	height: 432px;
	overflow: hidden;
	cursor: pointer;
	transition: transform 0.3s ease;

	&:hover {
		transform: translateY(-4px);
	}

	&:hover ${Thumbnail}::before {
		background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.85));
	}

	&:hover ${Thumbnail} {
		transform: scale(1.05);
	}
`;

const Overlay = styled.div`
	position: absolute;
	inset: 0;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7));
	z-index: 1;
`;

const Content = styled.div`
	position: absolute;
	z-index: 2;
	bottom: 32px;
	left: 32px;
	color: #fff;
	width: 50%;

	h4 {
		font-weight: 700;
		color: #f95c25;
		text-transform: uppercase;
		font-family: "DM Sans", sans !important;
		font-size: 16px;
		letter-spacing: 2px;
		line-height: 24px;
	}

	p {
		margin: 4px 0 0;
		font-weight: 700;
		color: #ffffff;
		font-family: "DM Sans", sans !important;
		font-size: 16px;
		line-height: 24px;
	}
`;

const EntryCardCard = ({ title, category, thumbnail, slug }) => {
	const navigate = useNavigate();

	const handleClick = () => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
		navigate(`/blog/${slug}`);
	};

	return (
		<CardWrapper onClick={handleClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && handleClick()}>
			<Thumbnail src={thumbnail} />
			<Overlay />
			<Content>
				<h4>{category}</h4>
				<p>{title}</p>
			</Content>
		</CardWrapper>
	);
};

export default EntryCardCard;

